// extracted by mini-css-extract-plugin
export var cardHeader = "_gd-0";
export var reorderHandle = "_gd-3";
export var titleArea = "_gd-1";
export var titleAreaWithHandle = "_gd-2";